import React from "react";
import ParameterSelectorReport from "../../pages/new/ParameterSelectorReport";

interface ReportWidgetProps {
  isEditMode?: boolean;
}

export default function ReportWidget({
  isEditMode = false,
}: ReportWidgetProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
      {/* Widget Header */}
      <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Report Generator
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Generate detailed sensor data reports
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <div className="h-3 w-3 bg-blue-500 rounded-full"></div>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Active
            </span>
          </div>
        </div>
      </div>

      {/* Widget Content */}
      <div className="p-0">
        <ParameterSelectorReport />
      </div>
    </div>
  );
}
